export const getColor = (parameter, value): string => {
  let color = '';
  const parameterClasses = {
    tt: ['tt', 'td', 'road_tt'],
    cond: ['road_condition'],
    water: ['wft'],
    rh: ['rh', 'road_rh'],
    n: ['n'],
  };

  if (parameterClasses.tt.indexOf(parameter) > -1) {
    if (value < -4) {
      color = '#000000';
    } else if (value <= -3) {
      color = '#0000FF';
    } else if (value <= -2) {
      color = '#007FFF';
    } else if (value <= -1.25) {
      color = '#3EC0FF';
    } else if (value <= -0.75) {
      color = '#00AE00';
    } else if (value <= -0.25) {
      color = '#00FF00';
    } else if (value <= 0.25) {
      color = '#D0D0D0';
    } else if (value <= 0.75) {
      color = '#FFFF00';
    } else if (value <= 1.25) {
      color = '#FF7F00';
    } else if (value <= 2) {
      color = '#FF0000';
    } else if (value <= -3) {
      color = '#C80032';
    } else {
      color = '#960096';
    }
    return color;
  }
  if (parameter === 'road_condition') {
    if (!value) {
      value = 0;
    }
    const colors = {
      0: '#00FF00',
      1: '#0000FF',
      2: '#0000FF',
      3: '#FF0000',
      4: '#FF0000',
      5: '#0000FF',
      6: '#FF0000',
      7: '#FF0000',
      8: '#FF0000',
      unknown: '#D0D0D0',
    };

    /*
          "CONDITION": {
      "0": "trocken",
      "1": "feucht",
      "2": "nass",
      "3": "Eis",
      "4": "Schnee/Eis",
      "5": "chem. nass",
      "6": "Schneematsch",
      "7": "kritisch",
      "8": "schneebedeckt"
    }
       */
    color = colors[value];
    return color;
  }
  if (parameterClasses.water.indexOf(parameter) > -1) {
    if (value <= 10) {
      color = '#008000';
    } else if (value <= 100) {
      color = '#87CEFA';
    } else if (value <= 1000) {
      color = '#00BFFF';
    } else {
      color = '#DC143C';
    }
    return color;
  }
  if (parameter === 'n') {
    const notBlue = value * 32 <= 255 ? value * 32 : 255;
    color = 'rgb(' + notBlue + ', ' + notBlue + ', 255)';
    return color;
  }
  if (parameter === 'ff') {
    if (value < 0.5) {
      color = '#8b07fe';
    } else if (value < 1.5) {
      color = '#5908fe';
    } else if (value < 2.5) {
      color = '#2b08fe';
    } else if (value < 3.5) {
      color = '#002dfe';
    } else if (value < 4.5) {
      color = '#005afe';
    } else if (value < 5.5) {
      color = '#008cfe';
    } else if (value < 6.5) {
      color = '#00c1fe';
    } else if (value < 7.5) {
      color = '#00e2ee';
    } else if (value < 8.5) {
      color = '#22b987';
    } else if (value < 9.5) {
      color = '#14ce13';
    } else if (value < 10.5) {
      color = '#04e202';
    } else if (value < 11.5) {
      color = '#05f902';
    } else if (value < 12.5) {
      color = '#b0ff57';
    } else if (value < 13.5) {
      color = '#fefd03';
    } else if (value < 14.5) {
      color = '#fedc03';
    } else if (value < 15.5) {
      color = '#fec002';
    } else if (value < 16.5) {
      color = '#fea402';
    } else if (value < 17.5) {
      color = '#fe8b02';
    } else if (value < 19.5) {
      color = '#e27101';
    } else if (value < 20.5) {
      color = '#e25901';
    } else if (value < 21.5) {
      color = '#d7401b';
    } else if (value < 22.5) {
      color = '#c12b1b';
    } else if (value < 23.5) {
      color = '#ab171b';
    } else if (value < 24.5) {
      color = '#a0001b';
    } else if (value < 25.5) {
      color = '#ab002c';
    } else if (value < 26.5) {
      color = '#c10059';
    } else {
      color = '#fe008b';
    }
    return color;
  }
  if (parameterClasses.rh.indexOf(parameter) > -1) {
    if (value < 10) {
      color = '#A26B3C';
    } else if (value < 20) {
      color = '#B77E53';
    } else if (value < 30) {
      color = '#CC9B7A';
    } else if (value < 40) {
      color = '#D8AF97';
    } else if (value < 50) {
      color = '#F2DACD';
    } else if (value < 60) {
      color = '#CCFDFF';
    } else if (value < 70) {
      color = '#99F8FF';
    } else if (value < 80) {
      color = '#65EFFF';
    } else if (value < 90) {
      color = '#32E3FF';
    } else {
      color = '#00BFE9';
    }
    return color;
  }
  if (parameter === 'rrr') {
    if (value < 0.03) {
      color = '#FFFFFF';
    } else if (value < 0.5) {
      color = '#C9E4F8';
    } else if (value < 2) {
      color = '#81C0EF';
    } else if (value < 8) {
      color = '#399DE6';
    } else if (value < 35) {
      color = '#256493';
    } else if (value < 150) {
      color = '#102B3F';
    } else {
      color = '#001420';
    }
    return color;
  }
  return 'white';
};

export const contrastColor = (parameter, value): string => {
  const color = getColor(parameter, value);
  return lightOrDark(color) === 'light' ? 'black' : 'white';
};

export const lightOrDark = (color: string): string => {
  if (color === 'white') {
    return 'dark';
  }
  if (color === 'black') {
    return 'light';
  }
  // Variables for red, green, blue values
  let r;
  let g;
  let b;
  let hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    const rgb = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );
    r = rgb[1];
    g = rgb[2];
    b = rgb[3];
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    r = parseInt(result[1], 16);
    g = parseInt(result[2], 16);
    b = parseInt(result[3], 16);
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 180) {
    return 'light';
  } else {
    return 'dark';
  }
};
